// theme enum
export enum ThemeEnum {
  LIGHT = 'light',
  DARK = 'dark',
  ORANGE = 'orange',
}

// app template enum
export enum TemplateEnum {
  SPORT789 = 'sport789',
  BLACK = 'black',
  BLUE = 'blue',
  PHLWIN = 'phlwin',
  BIGWIN = 'bigwin',
  BIGWINAPP = 'bigwinApp',
  AK8 = 'ak8',
  SVBET = 'svbet',
  SHIWAN_HAXI = 'SHIWAN_haxi',
}

// storage key
export enum StorageKeysEnum {
  APP_CONFIG = 'APP_CONFIG',
  APP_THEME = 'APP_THEME', // 主题
  APP_TEMPLATE = 'APP_TEMPLATE', // 模板
  APP_LANGUAGE = 'APP_LANGUAGE', // 语言
  APP_ACTIVE_FOOTER_TAB_MENU = 'APP_ACTIVE_FOOTER_TAB_MENU', // 底部菜单
  APP_MAIN_MENU = 'APP_MAIN_MENU', // 首页一级菜单原始数据
  APP_ACTIVE_MAIN_MENU_TAB = 'APP_ACTIVE_MAIN_MENU_TAB', // 游戏列表页主菜单
  APP_ACTIVE_SUB_MENU_TAB = 'APP_ACTIVE_SUB_MENU_TAB', // 游戏列表页二级菜单
  APP_ACTIVE_CHILD_MENU_TAB = 'APP_ACTIVE_CHILD_MENU_TAB', // 游戏列表页三级菜单
  APP_USER_INFO = 'APP_USER_INFO', // 登录用户信息
  POPUP_MODAL_LIST = 'POPUP_MODAL_LIST', // 首页弹窗列表
  POPUP_MODAL_STATUS_MAP = 'POPUP_MODAL_STATUS_MAP', // 首页弹窗状态
}

// auth storage key
export enum AuthStorageKeysEnum {
  LOGIN_SAVE_ACCOUNT_INFO = 'LOGIN_SAVE_ACCOUNT_INFO', // 登录保存的信息
}

// activity storage key
export enum ActivityKeysEnum {
  ACTIVITY_INFO = 'ACTIVITY_INFO', // 登录保存的信息
}

// 用户注册方式
export enum RegisterWayEnum {
  SMS_REGISTRATION = 1, // 短信注册
  ACCOUNT_REGISTRATION = 2, // 账号注册
  EMAIL_REGISTRATION = 3, // 邮箱注册
  AGENT_ACCOUNT_OPENING_REGISTRATION = 4, // 代理开户注册
  BULK_ACCOUNT_OPENING_REGISTRATION = 5, // 批量开户注册
}

export const isDev = process.env.NODE_ENV === 'development';
export const isProd = process.env.NODE_ENV === 'production';
